export const DateTimeString = 'yyyy-MM-dd HH:mm'
export const DatetimeSecondString = 'yyyy-MM-dd HH:mm:ss'
export const DateString = 'yyyy-MM-dd'
export const ShortDateString = 'yyyyMMdd'
export const TimeString = 'HH:mm'
export const YearDateSlush = 'yyyy/MM/dd'
